<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">RoRo Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="roro_fee" type="text" placeholder="RoRo fee" :class="{ 'is-danger': errors.roro_fee }">
                    <span class="icon is-left">
                        <i class="fas fa-ship"></i>
                    </span>
                    <p v-if="errors.roro_fee" class="help is-danger">{{ errors.roro_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            roro_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.roro_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'roro_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/RoroFeeInput.vue